import React from "react"

import Layout from "../components/Layout"
import SEO from "../components/SEO"
import Intro from "../blocks/Intro"
import Points from "../blocks/Points"
// import Description from "../blocks/Description"
import Contact from "../blocks/Contact"

const IndexPage = () => (
  <Layout>
    <SEO title="Attendee reward program" />
    <Intro />
    <Points />
    <Contact />
  </Layout>
)

export default IndexPage
